import React from 'react'
import './style.css'

const FamilyIslandPrivacyPolicy = () => {
  return (
    <div className="family-body">
      <main className="family-page">
        <header className="family-backbar">
          <div className="family-backbar-title">Family Island Energy Link Privacy Policy</div>
        </header>

        <section className="family-cards">
          <article className="family-card">
            <h2 className="family-card-title">Privacy Policy</h2>
            <p className="family-details">Effective date: 24 Oct, 2025</p>
            <p className="family-details">
              Family Island Energy Link ("we", "us", or "our") operates this mobile application (the "Service"). This
              Privacy Policy describes how we collect, use,
              disclose, and safeguard your information when you use the Service.
            </p>
            <p className="family-details">
              By using the Service, you agree to the collection and use of information in accordance with this policy. If
              you do not agree with the terms, please do not
              access the Service.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Information Collection And Use</h2>
            <p className="family-details">
              We collect different kinds of information to help provide and improve our Service.
            </p>
            <div className="family-section-title">Information We Collect</div>
            <ul className="family-dot-list">
              <li><span className="family-dot" aria-hidden="true"></span>Device Information such as device model and app version (e.g.,
                via react-native-device-info).</li>
              <li><span className="family-dot" aria-hidden="true"></span>Usage Data including in-app events and engagement metrics
                (e.g., via Firebase Analytics).</li>
              <li><span className="family-dot" aria-hidden="true"></span>Advertising Identifiers such as IDFA/GAID to deliver and
                measure ads (e.g., via Google Mobile Ads/AdMob and Unity Ads).</li>
              <li><span className="family-dot" aria-hidden="true"></span>Push Notification Tokens and message delivery data to send
                notifications (e.g., via Firebase Cloud Messaging/Notifee).</li>
              <li><span className="family-dot" aria-hidden="true"></span>Approximate Location derived from IP address for analytics and
                ad relevance. We do not request precise GPS location.</li>
            </ul>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Data Usage</h2>
            <p className="family-details">The data collected by Family Island Energy Link is used for multiple purposes:</p>
            <ul className="family-dot-list">
              <li><span className="family-dot"></span><span><strong>To Provide and Maintain the Service:</strong> We use your data to
                  operate the app, ensure functionality, and deliver requested features.</span></li>
              <li><span className="family-dot"></span><span><strong>To Improve and Personalize the Experience:</strong> Data helps us
                  understand user behavior and tailor content, layout, or ads to your preferences.</span></li>
              <li><span className="family-dot"></span><span><strong>To Analyze Usage:</strong> We use analytics tools (e.g. Firebase)
                  to track how users interact with the app and identify areas for improvement.</span></li>
              <li><span className="family-dot"></span><span><strong>To Communicate with You:</strong> We may send updates,
                  notifications, and relevant messages about features or policy changes.</span></li>
              <li><span className="family-dot"></span><span><strong>For Advertising and Marketing:</strong> Advertising identifiers may
                  be used to show relevant ads and measure campaign effectiveness.</span></li>
            </ul>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Third-Party Services</h2>
            <p className="family-details">We integrate services that may process data under their own privacy policies. Please review
              their policies:</p>
            <ul className="family-dot-list">
              <li><span className="family-dot"></span>Google Mobile Ads (AdMob): for ad serving and measurement.</li>
              <li><span className="family-dot"></span>Unity Ads: for showing rewarded video ads that allow users to earn in-app
                rewards.</li>
              <li><span className="family-dot"></span>Firebase Analytics: for usage analytics and performance insights.</li>
              <li><span className="family-dot"></span>Firebase Cloud Messaging (FCM): for push notification delivery.</li>
            </ul>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Children’s Privacy</h2>
            <p className="family-details">
              Our Service is not directed to children under the age of 13 (or the equivalent age as defined by applicable
              law). We do not knowingly collect personal information from children.
              If you are a parent or guardian and believe your child has provided us with personal data, please contact us
              so we can take appropriate action.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Security</h2>
            <p className="family-details">
              We implement commercially reasonable measures to protect your information; however, no method of transmission
              or storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Third-Party Links</h2>
            <p className="family-details">
              Our Service may include links to websites that are not managed by us. When you click a third-party link,
              you’ll be taken to their website. We recommend reviewing the privacy policy of every site you visit.
            </p>
            <p className="family-details">
              Please note that we have no control over, and are not responsible for, the content, privacy practices, or
              policies of these external sites or services.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Policy Updates</h2>
            <p className="family-details">
              We may revise this Privacy Policy from time to time. Any updates will be communicated by posting the revised
              Privacy Policy on this page. Before changes take effect, we will provide a clear notice on our Service and
              update the "effective date" at the top of this Privacy Policy.
            </p>
            <p className="family-details">
              We encourage you to review this Privacy Policy periodically to stay informed about any updates. All changes
              become effective immediately upon being posted on this page.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Contact</h2>
            <p className="family-details">
              If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us at:
              <br />
              Email: <a className="family-link" href="mailto:office@aavakar.com">office@aavakar.com</a>
            </p>
          </article>
        </section>
      </main>
    </div>
  )
}

export default FamilyIslandPrivacyPolicy;